import { render, staticRenderFns } from "./StatusTableWrapper.vue?vue&type=template&id=16f36372"
import script from "./StatusTableWrapper.vue?vue&type=script&lang=js"
export * from "./StatusTableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports